module.exports = __webpack_public_path__ + "static/img/244_TO8_2192_og.12b2a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/244_TO8_2192_og.jpg
// module id = nShX
// module chunks = 0